import axios from "axios";

// export var BASE_URL = "https://safe-api.winayak.com";
// if (window.location.hostname == 'uat-safe-app.winayak.com') {
// BASE_URL = "https://uat-safe-api.winayak.com";
// }
// export var BASE_URL = "http://safehand.local";
//export var EXTERNAL_URL = "https://safe-apiv2.winayak.com/api";

/***** LOCAL *********/
 //export var BASE_URL = "http://local.sfabackend.in";
 //export var EXTERNAL_URL = "http://local.sfalaravel.in/api";
 //export const springMoneyUrl = "https://api-suite-uat.safehands.in";
 //export const springMoneyUrl = "http://uatapi.springmoneyapisuite.money";

/***** STAGE *********/
//export var BASE_URL = "https://api.safehands.in";
//export var EXTERNAL_URL = "https://prod-auth.safehands.in/api";
//export const springMoneyUrl = "https://api-suite-uat.safehands.in";
	////export const springMoneyUrl = "https://api-suite-uat.manthan.money";
	// //  export const springMoneyUrl ="https://smallcase.safehands.in";

/***** TEST (MFD) *********/
//export var BASE_URL = "https://mfdapi.safehands.in";
//export var EXTERNAL_URL = "https://test-auth.safehands.in/api";
//export const springMoneyUrl = "https://api-suite-uat.safehands.in";

//export const springMoneyUrl = "https://api-suite-uat.manthan.money";
////export const springMoneyUrl ="https://smallcase.safehands.in";

/********NEW UI ***********/
//export var BASE_URL = "https://newuibackend.safehands.in";
//export var EXTERNAL_URL = "https://prod-auth.safehands.in/api";
//export const springMoneyUrl = "https://api-suite-uat.safehands.in";

/********OLD UI ***********/
//export var BASE_URL = "https://mfdapi.safehands.in";
//export var BASE_URL = "https://olduibackend.safehands.in";
//export var EXTERNAL_URL = "https://prod-auth.safehands.in/api";
//export const springMoneyUrl = "https://api-suite-uat.safehands.in";
//export var BASE_URL = "https://olduibackend.safehands.in";

/***** PROD *********/
export var BASE_URL = "https://prod-api.safehands.in";
export var EXTERNAL_URL = "https://prod-auth.safehands.in/api";
export const springMoneyUrl = "https://api-suite.safehands.in";
	//export const springMoneyUrl = "https://springmoneyapisuite.money";
	//export const springMoneyUrl = "https://api-suite.safehands.in";
	//export var BASE_URL = "https://api.plan360degree.com";
	//export var EXTERNAL_URL = "https://auth.plan360degree.com/api";
	//export const springMoneyUrl = "https://springmoneyapisuite.money";

/********** Spring Money (Smallcase) ******************/
//export const springMoneyUrl = "http://uatapi.springmoneyapisuite.money";


interface PropData {
  action: string;
  body?: any;
  isFormData?: boolean;
  isShowError?: boolean;
  id?: string;
}
const platform = btoa("web");//Encrypting platform and setting in header
/* ---------------------------------------------------------------------------
 * Global in-flight request tracking.
 *
 * Every API call in the app goes through the shared `axios` instance below, so
 * a single pair of interceptors gives an app-wide count of pending requests.
 * `GlobalSubmitGuard` (mounted in App.tsx) uses this to keep a Save/Submit
 * button disabled until the request its click triggered has settled — which
 * prevents accidental duplicate submissions from a double click.
 * ------------------------------------------------------------------------- */
let pendingRequestCount = 0;
const pendingRequestListeners = new Set<(count: number) => void>();
const notifyPendingRequests = () => {
  pendingRequestListeners.forEach((cb) => {
    try { cb(pendingRequestCount); } catch (e) { /* a bad listener must not break requests */ }
  });
};
export const getPendingRequestCount = (): number => pendingRequestCount;
export const onPendingRequestsChange = (cb: (count: number) => void): (() => void) => {
  pendingRequestListeners.add(cb);
  return () => { pendingRequestListeners.delete(cb); };
};
axios.interceptors.request.use((config) => {
  pendingRequestCount++;
  notifyPendingRequests();
  return config;
});
axios.interceptors.response.use(
  (response) => {
    pendingRequestCount = Math.max(0, pendingRequestCount - 1);
    notifyPendingRequests();
    return response;
  },
  (error) => {
    pendingRequestCount = Math.max(0, pendingRequestCount - 1);
    notifyPendingRequests();
    return Promise.reject(error);
  }
);
const WebService = {
  getAccesstoken: function (props: PropData) {
    // eslint-disable-line
    // this.addLoader(props.id);
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-Client-Platform": platform 
      };
      axios
        .post(`${BASE_URL}${props.action}`, bodyFormData, {
          headers: headers,
        })
        .then((response) => {
          localStorage.setItem("token", response.data.access_token);
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },
  externalgetAccesstoken: function (props: PropData) {
    // eslint-disable-line
    // this.addLoader(props.id);
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-Client-Platform": platform 
      };
      axios
        .post(`${EXTERNAL_URL}${props.action}`, bodyFormData, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  postAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      var headers = null;
      if (props.isFormData) {
        headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + localStorage.getItem("token"),
          "X-Client-Platform": platform 
        };
      } else {
        headers = {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
          "X-Client-Platform": platform 
        };
        //   headers = {
        //     "Content-Type": "application/application/json",
        //     'Accept': 'application/json',
        //     Authorization: "Bearer " + localStorage.getItem("token"),
        //   };
        // } else {
        //   headers = {
        //     "Content-Type": "application/json",
        //     'Accept': 'application/json',
        //     Authorization: "Bearer " + localStorage.getItem("token"),
        //   };
      }
      axios
        .post(
          `${BASE_URL}${props.action}`,
          props.isFormData ? bodyFormData : props.body,
          {
            headers: headers,
          }
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          // if (error && error.response && error.response.status === 401) {
          //   localStorage.clear();
          //   window.location.href = "/login";
          // }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },
  putAPI: function (props: PropData) {
    // eslint-disable-line
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
        "X-Client-Platform": platform 
      };
      axios
        .put(`${BASE_URL}${props.action}`, props.body, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  // getAccesstoken: function (props: PropData) {
  //   // eslint-disable-line
  //   // this.addLoader(props.id);
  //   return new Promise((resolve, reject) => {
  //     var bodyFormData = new URLSearchParams();
  //     for (let key in props.body) {
  //       bodyFormData.append(key, props.body[key]);
  //     }
  //     const headers = {
  //       "Content-Type": "application/x-www-form-urlencoded",
  //     };
  //     axios
  //       .post(`${LOGIN_BASE_URL}${props.action}`, bodyFormData, {
  //         headers: headers,
  //       })
  //       .then((response) => {
  //         localStorage.setItem("token", response.data.access_token);
  //         resolve(response.data);
  //       })
  //       .catch((error) => {
  //         props.isShowError ? reject(this.errorHandler(error)) : reject(error);
  //       });
  //   });
  // },

  getAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + localStorage.getItem("token"),
        "X-Client-Platform": platform
      };
      // let params = new URLSearchParams();
      // for (let key in props.body) {
      //   alert(key + '--' + props.body[key])
      //   params.set(key, props.body[key]);

      // }
      axios
        .get(`${BASE_URL}${props.action}`, {
          // params: params,
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  deleteAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + localStorage.getItem("token"),
        "X-Client-Platform": platform 
      };
      axios
        .delete(`${BASE_URL}${props.action}`, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  fileUploadAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + localStorage.getItem("token"),
        "X-Client-Platform": platform 
      };
      axios
        .post(`${BASE_URL}${props.action}`, props.body, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  fileDownloadAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "multipart/form-data",
        "Content-Disposition": "attachment;filename='reports.pdf'",
        //Authorization: "Bearer " + localStorage.getItem("token"),
        "X-Client-Platform": platform 
      };
      axios
        .post(`${BASE_URL}${props.action}`, props.body, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  errorHandler: function (error: any) {
    // if (error?.response) {
    //   error = error.response;
    // }

    var errorMessage;
    if (!error || !error.status) {
      errorMessage = "Server Not Responding";
    } else if (error.status === 401) {
      // localStorage.clear();
      // window.location.href = "/login";
    } else if (error.status === 500) {
      errorMessage =
        (error &&
          error.data &&
          error.data.ErrorDetails &&
          error.data.ErrorDetails.message) ||
        "An unkown exception has occur. Please Contact administrator";
    } else {
      errorMessage = error.data.error_description;
    }
    // toast.error(errorMessage);
    return errorMessage;
  },

  addLoader(id: any) {
    if (id) {
      var button = document.getElementById(id) as HTMLButtonElement | null;
      if (button != null) {
        button.disabled = true;
        var loader = document.createElement("i");
        loader.className = "bi bi-arrow-repeat mr-2";
        button.prepend(loader);
      }
    }
  },

  removeLoader(id: any) {
    if (id) {
      var button = document.getElementById(id) as HTMLButtonElement | null;
      if (button != null) {
        button.disabled = false;
        button.removeChild(button.childNodes[0]);
      }
    }
  },
  getExternalUrl() { 
return EXTERNAL_URL; 
},
};

export default WebService;
